var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/React.createElement("path", {
    id: "icon",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.26 13.27L20.99 19L19.5 20.49L13.77 14.76C12.7 15.53 11.41 16 10 16C6.41 16 3.5 13.09 3.5 9.5C3.5 5.91 6.41 3 10 3C13.59 3 16.5 5.91 16.5 9.5C16.5 10.91 16.03 12.2 15.26 13.27ZM10 5C7.51 5 5.5 7.01 5.5 9.5C5.5 11.99 7.51 14 10 14C12.49 14 14.5 11.99 14.5 9.5C14.5 7.01 12.49 5 10 5Z",
    fill: "#CAC4D0"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon);
export default __webpack_public_path__ + "static/media/Icon.63271dbc13c4c9d8f62f9955abf0f14f.svg";
export { ForwardRef as ReactComponent };